import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import PrecisionManufacturingOutlinedIcon from "@mui/icons-material/PrecisionManufacturingOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import LandingSectionHeader from "./LandingSectionHeader";
import { MessengerBrandInline } from "./MessengerBrandIcons";
import "./LandingAudienceSection.css";

const AUDIENCE = [
  {
    icon: <GroupsOutlinedIcon />,
    title: "HR и руководители",
    desc: "Онбординг, единые стандарты для филиалов, контроль прохождения",
  },
  {
    icon: <StorefrontOutlinedIcon />,
    title: "Ритейл, HoReCa, сервис",
    desc: "Обучение на смене, типовые ситуации с гостями и клиентами",
  },
  {
    icon: <HeadsetMicOutlinedIcon />,
    title: "Продажи и поддержка",
    desc: "Скрипты, ответы на возражения, проверка после обновления продукта",
  },
  {
    icon: <PrecisionManufacturingOutlinedIcon />,
    title: "Производство и выездные бригады",
    desc: "Инструкции, безопасность и подсказки на объекте",
  },
  {
    icon: <SchoolOutlinedIcon />,
    title: "Авторы и продавцы курсов",
    desc: "Своя программа по ссылке в мессенджере — без отдельного приложения и тяжёлой LMS",
  },
];

export default function LandingAudienceSection() {
  return (
    <section
      id="audience"
      className="landing-band landing-band--audience landing-section landing-section--audience"
    >
      <div className="landing-container">
        <LandingSectionHeader
          label="02 · Кому подходит"
          title="Кому подходит MOGAME"
          desc="Компаниям с командой, экспертам с собственными программами и всем, кому важно донести знания до людей там, где они уже общаются каждый день."
        />

        <div className="landing-band__panel landing-band__panel--audience">
          <ul className="landing-audience-grid">
            {AUDIENCE.map(({ icon, title, desc }) => (
              <li className="landing-audience-grid__item" key={title}>
                <span className="landing-audience-grid__icon">{icon}</span>
                <div>
                  <strong className="landing-audience-grid__title">{title}</strong>
                  <p className="landing-audience-grid__desc">{desc}</p>
                </div>
              </li>
            ))}
          </ul>

          <div className="landing-audience-grid__foot">
            <MessengerBrandInline size={26} spaced />
            <span>
              Сотрудники и ученики проходят материалы в Telegram или MAX — без регистрации
              и установки приложений
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
